import { DeleteOutlined } from '@ant-design/icons'
import { $getNodeByKey } from 'lexical'

import { useEditor } from '../../hooks/useEditor'
import { MenuButton } from '../../ui/MenuButton'

import { DeleteNodeButtonProps } from './interface'

export const DeleteNodeButton = ({ nodeKey }: DeleteNodeButtonProps) => {
  const editor = useEditor()
  const handleDelete = () => {
    editor.update(() => {
      const node = $getNodeByKey(nodeKey)
      node?.remove()
    })
  }

  return (
    <MenuButton tooltip='删除' onClick={handleDelete}>
      <DeleteOutlined />
    </MenuButton>
  )
}
